var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconFolderLockedLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconFolderLocked",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true,
      children: _path || (_path = _jsx("path", {
        d: "m764.34 56 225.883 338.824h929.732v564.705h-112.941V507.765H225.837V394.824h628.63L703.918 168.94H112.896v1411.765c0 31.172 25.412 56.47 56.47 56.47h957.742v112.942H169.367c-93.403 0-169.412-76.01-169.412-169.412V56H764.34Zm1042.72 1355.294v282.353c0 31.172-25.412 56.47-56.47 56.47h-338.824c-31.06 0-56.47-25.298-56.47-56.47v-282.353h451.764Zm-225.883-338.823c62.344 0 112.942 50.71 112.942 112.94v112.942h-225.883v-112.941c0-62.23 50.598-112.941 112.941-112.941Zm225.883 112.94c0-124.573-101.308-225.882-225.883-225.882-124.574 0-225.882 101.309-225.882 225.883v112.94h-112.941v395.295c0 93.402 76.01 169.412 169.412 169.412h338.823c93.403 0 169.412-76.01 169.412-169.412v-395.294H1807.06v-112.941Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconFolderLockedLine.glyphName = 'folder-locked';
IconFolderLockedLine.variant = 'Line';
IconFolderLockedLine.displayName = 'IconFolderLockedLine';
IconFolderLockedLine.allowedProps = [...SVGIcon.allowedProps];
export default IconFolderLockedLine;
export { IconFolderLockedLine };